import { HardHat } from 'lucide-react';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { RelatedCardProps } from '../types';
import { RelatedInternalCard } from './internal';
import { RelatedExternalCard } from './external';

export const RelatedCard = (props: RelatedCardProps) => {
  const task = props.data.task;
  if (!task) return null;

  if (task.scheduleType === 'internal')
    return <RelatedInternalCard {...props} icon={<HardHat className="h-5 w-5" />} />;

  const { icon, text } = task.appearance || {};

  return (
    <RelatedExternalCard
      {...props}
      icon={
        icon ? (
          <SvgConsumer id={icon} className="text-xl" />
        ) : (
          (text || task.name.trim().charAt(0)).toUpperCase()
        )
      }
    />
  );
};
